var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _g, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHouseSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 234,
    viewBox: "0 0 308 234",
    width: 308,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m45.6786 209.955c59.8244 32.06 156.8194 32.06 216.6434 0s59.817-84.033 0-116.0934c-59.818-32.0602-156.819-32.0602-216.6434 0-59.8241 32.0604-59.8175 84.0394 0 116.0934z",
    fill: "#f5f5f5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m65.1471 2.51349-4.634 2.64796c0-.20522.0398-.41044.0398-.60903v-1.32398c0-2.36993-1.6683-3.3099601-3.7204-2.14486-.8857.54054-1.6426 1.26804-2.2177 2.13161-.3376-2.985574-2.648-4.097717-5.521-2.455981-3.0716 1.774131-5.5673 6.090311-5.5673 9.645191v1.986c-.0095.8104.1672 1.6121.5163 2.3434l-3.8197 2.2045c-.6007.3918-1.1008.9196-1.4596 1.5407-.3588.621-.5664 1.3178-.6058 2.034 0 1.324.9268 1.8536 2.0654 1.1916l24.924-14.42478c.6011-.39146 1.1014-.91918 1.4603-1.54031s.5662-1.31815.6051-2.03444c.0132-1.31075-.9136-1.84696-2.0654-1.19158z",
    fill: "#ebebeb"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m84.8545 15.9255-3.4755 1.9859c.0097-.1543.0097-.309 0-.4634v-.9863c0-1.7874-1.2577-2.5156-2.8068-1.6219-.6663.4111-1.2372.9595-1.6748 1.6086-.2516-2.2507-2.0191-3.0848-4.164-1.8469-1.2251.7964-2.2445 1.8713-2.9751 3.1368-.7305 1.2655-1.1515 2.6859-1.2285 4.1451v1.5027c-.0131.602.1091 1.1992.3575 1.7477l-2.8863 1.6616c-.4531.2964-.8301.6954-1.1004 1.1647-.2702.4692-.4262.9955-.4553 1.5362 0 .993.6951 1.3968 1.5557.9003l18.8204-10.8699c.453-.295.83-.6928 1.1003-1.161.2703-.4681.4263-.9935.4554-1.5333.0331-.9996-.662-1.4034-1.5226-.9069z",
    fill: "#ebebeb"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m270.861 33.978-3.475 1.9859c.01-.1543.01-.309 0-.4634v-1.0062c0-1.7874-1.258-2.5156-2.807-1.6152-.669.4072-1.241.9563-1.675 1.6086-.251-2.2508-1.986-3.0915-4.164-1.8536-1.224.7972-2.242 1.8724-2.971 3.1378-.73 1.2655-1.149 2.6855-1.226 4.1441v1.5027c-.017.6016.103 1.1992.351 1.7477l-2.88 1.6616c-.454.2961-.832.6949-1.103 1.1641s-.429.9956-.459 1.5368c0 .993.702 1.3968 1.562.9003l18.821-10.8699c.453-.295.83-.6928 1.1-1.1609.27-.4682.426-.9936.456-1.5334.026-.9797-.669-1.3835-1.53-.887z",
    fill: "#ebebeb"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m63.3933 98.4359-51.6287 29.8091v2.483l47.3258 27.32 51.6286-29.803v-2.482z",
    fill: "#8ed6e8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m11.7646 128.245 47.3258 27.321v2.482l-47.3258-27.32z",
    fill: "#000",
    opacity: 0.15
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m59.0908 155.566 51.6282-29.803v2.482l-51.6282 29.803z",
    fill: "#000",
    opacity: 0.1
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m106.126 116.8-2.041 4.02.331.167 2.04-4.02z",
    fill: "#455a64"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m102.355 116.484-.315.196 1.989 3.214.315-.196z",
    fill: "#455a64"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m104.563 116.111v9.692c-.001.026-.01.052-.025.075-.015.022-.036.039-.061.05-.067.036-.142.055-.218.055s-.151-.019-.219-.055c-.025-.01-.048-.027-.064-.049-.017-.022-.026-.049-.028-.076v-9.692z",
    fill: "#455a64"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m111.891 113.099c0 .89-.264 1.761-.758 2.501-.495.74-1.198 1.317-2.021 1.658-.822.341-1.727.43-2.6.256-.874-.174-1.676-.602-2.305-1.232-.63-.63-1.059-1.432-1.232-2.305-.174-.873-.085-1.778.256-2.601.341-.822.918-1.525 1.658-2.02s1.61-.759 2.501-.759c1.193.002 2.337.477 3.181 1.321s1.319 1.988 1.32 3.181z",
    fill: "#8ed6e8"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m108.799 111.947c.583-1.827 1.198-2.542.808-2.767-.746-.423-1.596-.625-2.452-.581s-1.682.331-2.38.828c-.699.497-1.241 1.183-1.562 1.978-.322.794-.411 1.664-.255 2.507s.549 1.624 1.133 2.251 1.335 1.075 2.165 1.29 1.703.188 2.519-.076c.815-.265 1.538-.757 2.083-1.418-1.357.39-2.814-1.642-2.059-4.012z",
    fill: "#000",
    opacity: 0.2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m103.464 114.37c0 .626-.185 1.238-.533 1.758s-.842.926-1.42 1.165c-.578.24-1.214.303-1.8283.181-.6138-.123-1.1776-.424-1.6201-.866-.4426-.443-.744-1.007-.8661-1.621-.122-.613-.0594-1.25.1801-1.828s.6451-1.072 1.1655-1.42c.5203-.348 1.1321-.533 1.7579-.533.839 0 1.644.333 2.238.927.593.593.926 1.398.926 2.237z",
    fill: "#8ed6e8"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m100.3 111.206c-.6642 0-1.311.211-1.8472.602-.0861 1.926 1.5552 3.813 1.0923 4.449-.4634.635-1.5822.245-1.986-.298.2788.48.679.878 1.1604 1.155.4815.276 1.0273.421 1.5825.42.555-.001 1.1-.148 1.581-.426.48-.279.879-.679 1.156-1.16.276-.482.422-1.027.421-1.582-.001-.556-.148-1.101-.426-1.581-.278-.481-.678-.88-1.159-1.157s-1.027-.423-1.582-.422z",
    fill: "#000",
    opacity: 0.2
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m104.258 116.766c3.207 0 5.806-2.599 5.806-5.805 0-3.207-2.599-5.806-5.806-5.806-3.206 0-5.8054 2.599-5.8054 5.806 0 3.206 2.5994 5.805 5.8054 5.805z",
    fill: "#8ed6e8"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m109.905 112.285c-.219.94-.669 1.81-1.309 2.532-.64.723-1.451 1.274-2.358 1.604-.907.331-1.882.43-2.836.288-.955-.141-1.86-.518-2.632-1.097-.7726-.579-1.3885-1.341-1.7921-2.218-.4037-.877-.5824-1.84-.5199-2.803.0624-.964.364-1.896.8775-2.713.5135-.818 1.2225-1.494 2.0635-1.968-.491.289-.937.648-1.324 1.065-.2887 1.241-.1606 2.543.365 3.704.525 1.161 1.417 2.116 2.54 2.719s2.412.819 3.67.615c1.258-.203 2.414-.815 3.289-1.742z",
    fill: "#000",
    opacity: 0.1
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m20.1077 119.273-2.0403 4.02.3306.168 2.0403-4.02z",
    fill: "#455a64"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m16.3216 118.953-.3153.195 1.9897 3.214.3152-.195z",
    fill: "#455a64"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m18.537 118.58v9.692c-.0026.027-.0126.053-.0289.076-.0164.022-.0384.039-.0637.05-.0682.032-.1429.05-.2185.05s-.1503-.018-.2185-.05c-.0245-.011-.0456-.029-.0608-.051-.0151-.022-.0239-.048-.0252-.075v-9.692z",
    fill: "#455a64"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m25.8649 115.561c0 .891-.264 1.761-.7587 2.501-.4946.741-1.1976 1.318-2.0202 1.658-.8225.341-1.7276.43-2.6008.257-.8733-.174-1.6754-.603-2.3049-1.232-.6296-.63-1.0583-1.432-1.232-2.305-.1737-.874-.0845-1.779.2562-2.601.3407-.823.9177-1.526 1.6579-2.02.7403-.495 1.6106-.759 2.501-.759 1.1938 0 2.3388.474 3.183 1.318.8442.845 1.3185 1.99 1.3185 3.183z",
    fill: "#8ed6e8"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m22.7804 114.41c.5825-1.827 1.1982-2.542.8076-2.761-.6745-.388-1.4395-.591-2.2176-.589-.7585 0-1.5048.191-2.1696.556s-1.2265.893-1.633 1.533-.6446 1.373-.6922 2.13.0968 1.514.4199 2.2.8143 1.28 1.4281 1.725c.6138.446 1.3302.729 2.0828.824.7525.094 1.5168-.003 2.2219-.282.705-.28 1.3279-.733 1.8109-1.318-1.3372.39-2.8201-1.648-2.0588-4.018z",
    fill: "#000",
    opacity: 0.2
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m17.4385 116.839c0 .626-.1856 1.238-.5333 1.758-.3477.521-.8419.926-1.4201 1.166-.5782.239-1.2144.302-1.8282.18-.6139-.122-1.1777-.424-1.6202-.866-.4426-.443-.7439-1.007-.866-1.62-.1221-.614-.0595-1.25.18-1.829.2395-.578.6451-1.072 1.1655-1.42.5203-.347 1.1321-.533 1.758-.533.4158-.001.8276.08 1.2119.239.3844.159.7335.392 1.0275.686s.5271.643.6858 1.027c.1587.385.24.796.2391 1.212z",
    fill: "#8ed6e8"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m14.2734 113.675c-.6633-.003-1.3102.206-1.847.596-.0861 1.933 1.5491 3.819 1.0923 4.448s-1.5888.245-1.986-.291c.2788.48.679.879 1.1605 1.155.4814.277 1.0272.422 1.5824.421.5553-.002 1.1004-.149 1.5808-.427.4803-.279.8789-.679 1.1558-1.16.2768-.481.4222-1.027.4214-1.582s-.1477-1.101-.4259-1.581c-.2782-.481-.6779-.88-1.159-1.157s-1.0267-.422-1.582-.422z",
    fill: "#000",
    opacity: 0.2
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "m18.2266 119.229c3.2063 0 5.8056-2.599 5.8056-5.806 0-3.206-2.5993-5.805-5.8056-5.805-3.2064 0-5.8057 2.599-5.8057 5.805 0 3.207 2.5993 5.806 5.8057 5.806z",
    fill: "#8ed6e8"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "m23.8725 114.754c-.2217.937-.6733 1.804-1.3139 2.523-.6407.719-1.4504 1.267-2.3559 1.595s-1.8783.425-2.8308.282c-.9524-.142-1.8543-.519-2.6244-1.098-.7701-.578-1.3841-1.339-1.7866-2.213-.4024-.875-.5807-1.837-.5187-2.798s.3624-1.891.874-2.707 1.2183-1.491 2.0563-1.966c-.5008.289-.9577.648-1.357 1.066-.2862 1.24-.1567 2.539.3684 3.698s1.4167 2.113 2.5374 2.715 2.4084.819 3.6645.617 2.411-.811 3.2867-1.734z",
    fill: "#000",
    opacity: 0.1
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "m75.1108 138.864 7.2091-4.158 6.4677 3.734-7.2025 4.151z",
    fill: "#f0f0f0"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "m24.6809 128.245-.0066-22.355 34.4235 19.866v22.362z",
    fill: "#f0f0f0"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "m24.6743 114.761 34.4235 19.879v-8.884l-34.4235-19.866z",
    fill: "#e0e0e0"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "m97.8109 125.756v-21.733l-12.9088-3.105v-2.4821l-25.8044 27.3201v22.362z",
    fill: "#fafafa"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "m84.9019 98.4359v2.4821l15.0602 3.727v-2.482z",
    fill: "#263238"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "m65.5513 82.2899 34.4103 19.8731-15.0603-3.7272-34.4169-19.8729z",
    fill: "#37474f"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "m56.9391 129.496 27.9691-31.0602v-2.4824l-30.1206 34.7746z",
    fill: "#37474f"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "m50.4917 76.0804 34.4169 19.873-30.0676 34.8076-34.4699-19.906z",
    fill: "#455a64"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "m39.6938 108.28 4.3361 2.502v6.282l-4.3361-2.482z",
    fill: "#263238"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "m44.0308 110.782 4.3294-2.502v3.819l-4.3294 4.965z",
    fill: "#37474f"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "m44.0303 104.023-4.7862 2.761v1.251l4.7862 2.747 4.7796-2.747v-1.251z",
    fill: "#f5f5f5"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "m39.2441 108.035 4.7862 2.747v-1.251l-4.7862-2.747z",
    fill: "#e0e0e0"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "m48.8103 108.035-4.7795 2.747v-1.251l4.7795-2.747z",
    fill: "#ebebeb"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "m40.853 106.784 3.1776-1.834 3.1775 1.834-3.1775 1.827z",
    fill: "#8ed6e8"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "m44.0306 104.95v3.661l-3.1776-1.827z",
    fill: "#37474f"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "m44.0308 104.95 3.1775 1.834-3.1775 1.827z",
    fill: "#263238"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "m61.8848 131.602 9.6849-5.588v7.454l-9.6849 5.588z",
    fill: "#455a64"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "m71.1394 133.217v-6.951l-9.2546 5.336v6.957z",
    fill: "#e0e0e0"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "m71.5697 133.468-.4303-.251-9.2546 5.342v.497z",
    fill: "#37474f"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "m61.8848 135.329 9.6849-5.588v-.503l-9.6849 5.587z",
    fill: "#455a64"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "m85.5503 117.932 9.6783-5.588v7.454l-9.6783 5.588z",
    fill: "#455a64"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "m94.7983 119.547v-6.951l-9.248 5.335v6.958z",
    fill: "#e0e0e0"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "m95.2286 119.798-.4303-.251-9.248 5.342v.497z",
    fill: "#37474f"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "m85.5503 121.659 9.6783-5.588v-.503l-9.6783 5.594z",
    fill: "#455a64"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "m75.1108 138.864v-14.902l7.2091-4.157v14.901z",
    fill: "#37474f"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "m82.0684 134.514v-14.563l-6.9576 4.011v14.564z",
    fill: "#455a64"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "m82.3204 119.805-.2516.146v14.563l.2516.192z",
    fill: "#263238"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "m51.2397 128.682-5.0576-2.919v7.447l5.0576 2.92z",
    fill: "#455a64"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "m46.6123 132.959v-6.951l4.6273 2.674v6.951z",
    fill: "#fafafa"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "m46.1821 133.21.4303-.251 4.6273 2.674v.497z",
    fill: "#37474f"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "m51.2397 132.383-5.0576-2.9v-.503l5.0576 2.9z",
    fill: "#455a64"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "m46.6123 126.008 4.6273 2.674v1.437l-4.6273-2.655z",
    fill: "#f5f5f5"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "m36.1797 119.984-5.0576-2.92v7.454l5.0576 2.92z",
    fill: "#455a64"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "m31.5581 124.267v-6.951l4.6207 2.668v6.951z",
    fill: "#fafafa"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "m31.1221 124.518.4369-.251 4.6207 2.668v.503z",
    fill: "#37474f"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "m36.1797 123.684-5.0576-2.899v-.503l5.0576 2.899z",
    fill: "#455a64"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "m31.5581 117.316 4.6207 2.668v1.377l-4.6207-2.648z",
    fill: "#f5f5f5"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "m242.468 96.2645-51.628 29.8095v2.482l51.628 29.81 51.636-29.81v-2.482z",
    fill: "#8ed6e8"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "m190.84 126.074 51.635 29.809-.007 2.483-51.628-29.81z",
    fill: "#000",
    opacity: 0.15
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "m242.476 155.883 51.629-29.809v2.482l-51.636 29.81z",
    fill: "#000",
    opacity: 0.1
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "m289.653 117.192-2.04 4.02.33.168 2.041-4.02z",
    fill: "#455a64"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "m286.401 115.746-.315.197 2.003 3.213.315-.197z",
    fill: "#455a64"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "m288.1 116.508v9.692c-.002.027-.011.053-.026.075s-.036.04-.061.05c-.067.036-.142.055-.218.055s-.151-.019-.218-.055c-.026-.01-.048-.027-.064-.05-.016-.022-.026-.048-.029-.075v-9.692z",
    fill: "#455a64"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "m295.428 113.496c0 .89-.264 1.761-.758 2.501-.495.74-1.198 1.317-2.02 1.658-.823.341-1.728.43-2.601.256-.874-.174-1.676-.602-2.305-1.232-.63-.629-1.059-1.432-1.232-2.305-.174-.873-.085-1.778.256-2.601.341-.822.918-1.525 1.658-2.02.74-.494 1.611-.758 2.501-.758 1.194 0 2.339.474 3.183 1.318s1.318 1.989 1.318 3.183z",
    fill: "#8ed6e8"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "m292.337 112.344c.582-1.827 1.204-2.542.807-2.767-.746-.422-1.596-.623-2.452-.578s-1.682.333-2.379.831c-.698.498-1.239 1.184-1.56 1.979-.321.794-.409 1.664-.252 2.507.156.842.55 1.623 1.135 2.25.584.626 1.336 1.073 2.165 1.287.83.214 1.704.187 2.519-.078s1.537-.758 2.082-1.419c-1.337.39-2.813-1.662-2.065-4.012z",
    fill: "#000",
    opacity: 0.2
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "m287.001 114.767c0 .626-.186 1.238-.534 1.758-.347.52-.842.926-1.42 1.166-.578.239-1.214.302-1.828.18s-1.178-.424-1.62-.866c-.443-.443-.744-1.007-.866-1.621-.122-.613-.06-1.25.18-1.828.239-.578.645-1.072 1.165-1.42.521-.348 1.132-.533 1.758-.533.839 0 1.644.333 2.238.927.593.593.927 1.398.927 2.237z",
    fill: "#8ed6e8"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "m283.837 111.603c-.664.001-1.31.211-1.847.602-.086 1.927 1.556 3.813 1.099 4.449-.457.635-1.589.245-1.986-.298.279.48.679.878 1.16 1.155.482.277 1.028.422 1.583.42.555-.001 1.1-.148 1.581-.426.48-.279.879-.679 1.155-1.16.277-.481.423-1.027.422-1.582-.001-.556-.148-1.101-.426-1.581-.278-.481-.678-.88-1.159-1.157s-1.027-.423-1.582-.422z",
    fill: "#000",
    opacity: 0.2
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "m287.796 117.164c3.206 0 5.806-2.6 5.806-5.806s-2.6-5.806-5.806-5.806-5.806 2.6-5.806 5.806 2.6 5.806 5.806 5.806z",
    fill: "#8ed6e8"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "m293.443 112.708c-.225.937-.679 1.803-1.321 2.52-.643.717-1.453 1.264-2.36 1.59-.906.326-1.879.421-2.831.278-.952-.144-1.854-.522-2.623-1.101-.77-.579-1.384-1.34-1.786-2.215s-.581-1.836-.519-2.797.362-1.891.872-2.708c.511-.816 1.217-1.492 2.054-1.968-.505.285-.965.644-1.363 1.066-.289 1.241-.161 2.542.364 3.703s1.418 2.117 2.541 2.719c1.122.603 2.412.819 3.67.616 1.258-.204 2.413-.816 3.288-1.742z",
    fill: "#000",
    opacity: 0.1
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "m199.167 116.98-2.041 4.02.331.168 2.04-4.02z",
    fill: "#455a64"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "m195.938 115.856-.315.196 2.003 3.213.316-.196z",
    fill: "#455a64"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "m197.612 116.296v9.692c-.003.027-.013.053-.03.075-.016.022-.037.039-.062.051-.069.032-.143.049-.219.049s-.15-.017-.218-.049c-.024-.013-.044-.031-.059-.053s-.024-.047-.027-.073v-9.692z",
    fill: "#455a64"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "m204.94 113.278c0 .89-.264 1.76-.759 2.501-.494.74-1.197 1.317-2.02 1.658-.822.34-1.727.429-2.601.256-.873-.174-1.675-.603-2.305-1.232-.629-.63-1.058-1.432-1.231-2.305-.174-.873-.085-1.778.256-2.601.34-.823.917-1.526 1.658-2.02.74-.495 1.61-.759 2.501-.759 1.193.002 2.337.477 3.181 1.321.844.843 1.318 1.987 1.32 3.181z",
    fill: "#8ed6e8"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "m201.849 112.126c.583-1.827 1.198-2.542.808-2.767-.746-.423-1.596-.623-2.452-.579-.855.045-1.68.332-2.378.829s-1.239 1.183-1.561 1.977c-.321.794-.41 1.663-.254 2.506.155.842.548 1.623 1.131 2.25.584.627 1.334 1.075 2.163 1.291.829.215 1.703.189 2.518-.074.815-.264 1.538-.755 2.084-1.415-1.331.384-2.814-1.648-2.059-4.018z",
    fill: "#000",
    opacity: 0.2
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "m196.514 114.549c.001.626-.183 1.238-.53 1.759-.347.522-.841.928-1.419 1.169-.578.24-1.215.304-1.829.183-.614-.122-1.179-.423-1.622-.865s-.745-1.006-.868-1.62c-.122-.614-.06-1.25.179-1.829.24-.579.645-1.073 1.166-1.421.52-.348 1.132-.534 1.758-.534.838 0 1.642.332 2.236.924.593.592.927 1.396.929 2.234z",
    fill: "#8ed6e8"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "m193.349 111.384c-.664-.002-1.311.206-1.847.596-.086 1.933 1.555 3.813 1.092 4.449-.464.635-1.589.245-1.986-.292.279.481.679.879 1.16 1.155.482.277 1.028.422 1.583.421s1.1-.148 1.581-.427c.48-.278.879-.678 1.155-1.16.277-.481.423-1.027.422-1.582s-.148-1.1-.426-1.581c-.278-.48-.678-.879-1.159-1.156s-1.027-.423-1.582-.423z",
    fill: "#000",
    opacity: 0.2
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "m197.302 116.945c3.206 0 5.805-2.599 5.805-5.806 0-3.206-2.599-5.805-5.805-5.805-3.207 0-5.806 2.599-5.806 5.805 0 3.207 2.599 5.806 5.806 5.806z",
    fill: "#8ed6e8"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "m202.955 112.47c-.22.939-.671 1.809-1.312 2.53s-1.452 1.271-2.358 1.601c-.907.329-1.882.427-2.836.285-.955-.142-1.858-.519-2.63-1.098s-1.387-1.341-1.791-2.218c-.403-.876-.581-1.839-.519-2.802.063-.963.364-1.895.877-2.712.514-.817 1.222-1.493 2.062-1.968-.502.287-.959.646-1.357 1.066-.283 1.24-.151 2.538.376 3.695.526 1.158 1.418 2.11 2.538 2.712 1.12.601 2.407.818 3.662.617 1.256-.2 2.411-.807 3.288-1.728z",
    fill: "#000",
    opacity: 0.1
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "m252.869 83.3027 4.33 2.5024v5.0046l-4.33-2.5023z",
    fill: "#e0e0e0"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "m257.198 85.8051 4.336-2.5024v10.0027l-4.336-2.4957z",
    fill: "#f0f0f0"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "m257.198 79.0461-4.78 2.7539v1.2512l4.78 2.7539 4.786-2.7539v-1.2512z",
    fill: "#455a64"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "m252.418 83.0512 4.78 2.7539v-1.2512l-4.78-2.7539z",
    fill: "#37474f"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "m261.984 83.0512-4.786 2.7539v-1.2512l4.786-2.7539z",
    fill: "#263238"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "m254.021 81.8 3.177-1.8271 3.184 1.8271-3.184 1.8337z",
    fill: "#8ed6e8"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "m257.198 79.9729v3.6608l-3.177-1.8337z",
    fill: "#37474f"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "m257.198 79.9729 3.184 1.8271-3.184 1.8337z",
    fill: "#263238"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "m242.476 133.528-.007-22.356 12.889 7.448v22.355z",
    fill: "#f0f0f0"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "m242.469 111.172 12.889 7.448v8.904l-12.889-7.435z",
    fill: "#e0e0e0"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "m281.195 126.074v-22.355l-12.935-7.4545-12.902 22.3555v22.355z",
    fill: "#fafafa"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "m253.226 122.347 15.034-26.0826v-2.4824l-17.185 29.809z",
    fill: "#37474f"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "m242.469 78.8806 25.791 14.9014-17.185 29.809-8.599-4.971z",
    fill: "#455a64"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "m268.26 96.2644 15.087 8.6916 2.151-1.238-17.238-9.936z",
    fill: "#263238"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "m273.655 115.985 5.057-2.899v7.454l-5.057 2.899z",
    fill: "#455a64"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "m278.282 120.288v-6.951l-4.627 2.648v6.951z",
    fill: "#e0e0e0"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "m278.712 120.54-.43-.252-4.627 2.648v.503z",
    fill: "#37474f"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "m273.655 119.712 5.057-2.899v-.503l-5.057 2.899z",
    fill: "#455a64"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "m257.781 125.14 5.057-2.899v7.447l-5.057 2.907z",
    fill: "#455a64"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "m262.408 129.443v-6.957l-4.627 2.655v6.95z",
    fill: "#e0e0e0"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "m262.838 129.688-.43-.245-4.627 2.648v.504z",
    fill: "#37474f"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "m257.781 128.867 5.057-2.899v-.503l-5.057 2.899z",
    fill: "#455a64"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "m265.036 107.446 6.454-3.727v5.587l-6.454 3.727z",
    fill: "#455a64"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "m271.06 109.054v-5.091l-6.024 3.482v5.091z",
    fill: "#e0e0e0"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "m271.49 109.306-.43-.252-6.024 3.482v.497z",
    fill: "#37474f"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "m283.346 104.956h-2.151v-1.237z",
    fill: "#000"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "m264.659 135.6v-14.901l7.209-4.158v14.902z",
    fill: "#37474f"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "m271.617 131.251v-14.564l-6.958 4.012v14.563z",
    fill: "#455a64"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "m271.868 116.541-.251.146v14.564l.251.192z",
    fill: "#263238"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "m242.469 133.528v-22.356l-12.883 7.448v22.355z",
    fill: "#fafafa"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "m242.469 111.172-12.883 7.448v8.904l12.889-7.435z",
    fill: "#f5f5f5"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "m203.75 126.074v-22.355l12.928-7.4545 12.909 22.3555v22.355z",
    fill: "#ebebeb"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "m231.718 122.347-15.04-26.0826v-2.4824l17.192 29.809z",
    fill: "#455a64"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "m242.469 78.8806-25.791 14.9014 17.192 29.809 8.599-4.971z",
    fill: "#37474f"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "m216.678 96.2644-15.08 8.6916-2.152-1.238 17.232-9.936z",
    fill: "#263238"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "m213.109 116.554-5.057-2.899v7.454l5.057 2.893z",
    fill: "#455a64"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "m208.483 120.857v-6.957l4.627 2.654v6.951z",
    fill: "#fafafa"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "m208.483 113.9 4.627 2.674v.921l-4.627-2.655z",
    fill: "#f5f5f5"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "m220.637 120.917 4.627 2.674v.921l-4.627-2.655z",
    fill: "#f5f5f5"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "m208.052 121.109.43-.252 4.627 2.648v.497z",
    fill: "#37474f"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "m213.109 120.281-5.057-2.899v-.503l5.057 2.899z",
    fill: "#455a64"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "m219.908 107.446-6.454-3.727v5.587l6.454 3.727z",
    fill: "#455a64"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "m213.884 109.054v-5.091l6.024 3.482v5.091z",
    fill: "#fafafa"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "m213.884 103.963 6.024 3.482v.921l-6.024-3.456z",
    fill: "#f5f5f5"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "m213.454 109.306.43-.252 6.024 3.482v.497z",
    fill: "#37474f"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "m201.598 104.956h2.152v-1.237z",
    fill: "#000"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "m225.264 123.591-5.057-2.919v7.447l5.057 2.92z",
    fill: "#455a64"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "m220.637 127.868v-6.951l4.627 2.674v6.951z",
    fill: "#fafafa"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "m220.207 128.119.43-.251 4.627 2.674v.497z",
    fill: "#37474f"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "m225.264 127.292-5.057-2.899v-.504l5.057 2.9z",
    fill: "#455a64"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "m220.637 120.917 4.627 2.674v.921l-4.627-2.655z",
    fill: "#f5f5f5"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "m251.075 123.591-6.461-3.733v6.871l6.461 3.727z",
    fill: "#263238"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "m245.01 126.498v-6.409l6.064 3.502v6.408z",
    fill: "#fafafa"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "m245.01 120.089v1.49l6.064 3.509v-1.497z",
    fill: "#f0f0f0"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "m244.614 126.729.397-.231 6.064 3.501v.457z",
    fill: "#37474f"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "m244.614 123.294.397-.232 6.064 3.502v.463z",
    fill: "#37474f"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "m247.711 128.517.398.225v-6.865l-.398-.232z",
    fill: "#37474f"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "m238.053 138.526 1.146-.662c.315-1.862.362-3.759.139-5.634-.576-3.654-3.072-4.918-3.972-4.554-.901.364-1.112 1.45.523 3.561 1.478 2.138 2.236 4.691 2.164 7.289z",
    fill: "#8ed6e8"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "m238.053 138.526 1.146-.662c.315-1.862.362-3.759.139-5.634-.576-3.654-3.072-4.918-3.972-4.554-.901.364-1.112 1.45.523 3.561 1.478 2.138 2.236 4.691 2.164 7.289z",
    fill: "#000",
    opacity: 0.2
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "m238.47 137.096c-.011-.001-.022-.004-.031-.009-.01-.005-.019-.012-.026-.021s-.012-.019-.014-.03c-.003-.011-.003-.022-.002-.033.477-3.422-.9-7.176-2.449-8.692-.015-.015-.023-.035-.023-.056s.008-.041.023-.056.035-.023.056-.023.042.008.057.023c1.575 1.536 2.979 5.349 2.502 8.831-.002.01-.005.02-.011.029-.005.009-.013.017-.021.023-.009.007-.019.011-.029.013-.011.003-.021.003-.032.001z",
    fill: "#fff"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "m234.876 140.386c-.185.106-.556-.119-.701-.218-.244-.168-.44-.396-.57-.662-.146-.3-.197-.637-.145-.967.028-.174.068-.347.119-.516.053-.172.099-.338.145-.503.061-.163.085-.337.073-.51-.045-.167-.123-.322-.23-.458-.107-.135-.24-.247-.392-.33-.17-.098-.315-.235-.423-.4-.108-.164-.176-.351-.199-.547.021-.321.149-.626.364-.867.198-.251.43-.47.609-.735.122-.142.194-.321.206-.508.012-.188-.037-.374-.14-.531-.167-.257-.314-.527-.437-.807-.06-.141-.079-.296-.054-.448.024-.151.091-.292.193-.406.101-.076.215-.13.336-.161.122-.031.248-.037.372-.018.236.027.462.106.662.232.662.364 1.033 1.145 1.728 1.423.275.088.556.156.841.205.143.025.279.081.399.163s.221.189.296.314c.258.509-.218 1.138-.04 1.681.179.543.629.662.887 1.099.111.187.156.407.126.622-.023.369-.113.73-.265 1.066-.173.33-.367.649-.582.953z",
    fill: "#8ed6e8"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "m234.876 140.386c-.186.106-.556-.119-.702-.218-.243-.168-.439-.396-.569-.662-.147-.3-.198-.637-.146-.967.029-.174.069-.347.119-.516.053-.172.1-.338.146-.503.06-.163.085-.337.073-.51-.045-.167-.124-.322-.231-.458-.107-.135-.24-.247-.391-.33-.171-.098-.316-.235-.424-.4-.108-.164-.176-.351-.199-.547.022-.321.15-.626.364-.867.199-.251.431-.47.609-.735.122-.142.195-.321.207-.508.012-.188-.037-.374-.14-.531-.168-.257-.314-.527-.437-.807-.061-.141-.079-.296-.055-.448.025-.151.092-.292.194-.406.1-.076.214-.13.336-.161.121-.031.248-.037.372-.018.235.027.461.106.662.232.662.364 1.033 1.145 1.728 1.423.275.088.556.156.841.205.143.025.279.081.399.163s.22.189.296.314c.258.509-.219 1.138-.04 1.681s.629.662.887 1.099c.111.187.155.407.126.622-.024.369-.113.73-.265 1.066-.173.33-.368.649-.583.953z",
    fill: "#000",
    opacity: 0.1
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "m236.737 139.4c-.021-.003-.041-.013-.055-.029-.015-.016-.023-.036-.025-.057.139-3.244-1.39-6.825-2.502-7.865-.008-.007-.014-.016-.018-.026-.005-.01-.007-.02-.008-.031 0-.011.002-.021.006-.031.004-.011.009-.02.017-.028.007-.007.016-.014.026-.018s.02-.007.031-.007c.011-.001.021.001.032.005.01.004.019.01.027.017 1.132 1.059 2.694 4.7 2.555 7.99-.002.022-.012.042-.028.057-.015.015-.036.023-.058.023z",
    fill: "#fff"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "m236.247 135.567c-.77-.209-1.56-.336-2.357-.378-.011 0-.022-.002-.032-.006-.01-.005-.019-.011-.026-.019-.008-.008-.014-.018-.017-.028-.004-.011-.005-.022-.004-.033.001-.021.011-.042.027-.056.016-.015.037-.023.059-.023.811.042 1.614.173 2.396.39.01.004.02.009.028.015.008.007.014.015.019.024s.008.019.009.03c.001.01 0 .021-.003.031-.007.019-.021.035-.04.045-.018.009-.039.012-.059.008z",
    fill: "#fff"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "m264.659 135.6 7.209-4.157 6.468 3.733-7.209 4.151z",
    fill: "#f0f0f0"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "m148.083 146.404-62.9292 36.33v2.793l65.3452 37.727 62.922-36.33v-2.793z",
    fill: "#8ed6e8"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "m177.124 196.708 7.215 4.217 12.121-6.997-7.235-4.204z",
    fill: "#f0f0f0"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "m85.1538 182.734 65.3452 37.727v2.793l-65.3452-37.727z",
    fill: "#000",
    opacity: 0.15
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "m150.499 220.461 62.922-36.33v2.793l-62.922 36.33z",
    fill: "#000",
    opacity: 0.1
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "m206.35 171.759-2.805 5.526.455.23 2.804-5.525z",
    fill: "#263238"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "m201.14 171.29-.428.265 2.736 4.418.427-.265z",
    fill: "#263238"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "m204.166 170.778v13.313c-.004.037-.018.073-.04.103s-.052.054-.086.069c-.093.048-.197.072-.301.072-.105 0-.208-.024-.301-.072-.034-.015-.063-.039-.084-.07-.021-.03-.033-.065-.036-.102v-13.313z",
    fill: "#263238"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "m208.065 172.817c3.415 0 6.183-2.768 6.183-6.183s-2.768-6.183-6.183-6.183-6.183 2.768-6.183 6.183 2.768 6.183 6.183 6.183z",
    fill: "#455a64"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "m210.006 165.059c.794-2.516 1.648-3.496 1.105-3.8-1.024-.58-2.192-.856-3.368-.796-1.175.061-2.309.456-3.268 1.139-.958.683-1.702 1.626-2.144 2.717-.441 1.091-.562 2.285-.348 3.443.214 1.157.754 2.229 1.556 3.091.802.861 1.834 1.475 2.973 1.771 1.139.295 2.339.259 3.459-.105 1.12-.363 2.112-1.038 2.861-1.946-1.827.53-3.859-2.257-2.826-5.514z",
    fill: "#37474f"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "m198.328 172.731c2.398 0 4.342-1.944 4.342-4.343 0-2.398-1.944-4.342-4.342-4.342-2.399 0-4.343 1.944-4.343 4.342 0 2.399 1.944 4.343 4.343 4.343z",
    fill: "#455a64"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "m198.327 164.039c-.912-.001-1.802.286-2.542.821-.112 2.648 2.138 5.243 1.51 6.117-.629.874-2.185.331-2.721-.404.384.657.934 1.202 1.595 1.579.661.378 1.409.575 2.17.572.761-.002 1.508-.205 2.166-.588.658-.382 1.204-.931 1.584-1.591.379-.66.578-1.408.577-2.169s-.202-1.509-.583-2.168-.929-1.206-1.588-1.587c-.659-.38-1.407-.581-2.168-.582z",
    fill: "#37474f"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "m211.511 165.519c1.012-4.284-1.642-8.577-5.926-9.588s-8.577 1.642-9.588 5.926 1.642 8.577 5.926 9.588 8.577-1.642 9.588-5.926z",
    fill: "#455a64"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "m211.521 165.522c-.31 1.278-.933 2.458-1.811 3.436-.879.978-1.987 1.722-3.224 2.166-1.238.445-2.566.575-3.866.379-1.3-.195-2.531-.71-3.583-1.499-1.052-.788-1.892-1.826-2.444-3.019-.553-1.193-.8-2.504-.721-3.816.079-1.313.483-2.585 1.175-3.703.692-1.117 1.651-2.046 2.79-2.702-.691.394-1.32.887-1.867 1.463-.138.597-.209 1.207-.212 1.82-.013 1.602.458 3.17 1.351 4.499.894 1.33 2.168 2.358 3.657 2.95 1.488.592 3.12.72 4.683.368 1.562-.352 2.982-1.169 4.072-2.342z",
    fill: "#37474f"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "m97.5114 170.181-2.8044 5.525.4546.231 2.8043-5.526z",
    fill: "#263238"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "m92.3145 169.741-.4278.265 2.7353 4.419.4278-.265z",
    fill: "#263238"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "m95.3552 169.223v13.312c-.0026.037-.0151.072-.036.103-.021.03-.0497.054-.0832.069-.0933.048-.1965.073-.3012.073s-.208-.025-.3012-.073c-.0343-.015-.064-.039-.0861-.069s-.0358-.066-.0397-.103v-13.312z",
    fill: "#263238"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "m99.2406 171.268c3.4144 0 6.1834-2.768 6.1834-6.183s-2.769-6.183-6.1834-6.183c-3.4148 0-6.183 2.768-6.183 6.183s2.7682 6.183 6.183 6.183z",
    fill: "#455a64"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "m101.18 163.503c.794-2.516 1.642-3.495 1.105-3.8-1.024-.58-2.192-.856-3.3675-.795s-2.3092.456-3.2678 1.139-1.7024 1.625-2.144 2.716c-.4415 1.091-.5624 2.286-.3486 3.443.2139 1.158.7537 2.23 1.556 3.091s1.8338 1.476 2.9732 1.771 2.3397.259 3.4587-.104c1.12-.363 2.112-1.039 2.862-1.947-1.828.537-3.866-2.257-2.827-5.514z",
    fill: "#37474f"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "m89.5018 171.175c2.3984 0 4.3427-1.944 4.3427-4.342 0-2.399-1.9443-4.343-4.3427-4.343-2.3983 0-4.3426 1.944-4.3426 4.343 0 2.398 1.9443 4.342 4.3426 4.342z",
    fill: "#455a64"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "m89.5028 162.49c-.9117-.001-1.8008.284-2.5421.814-.1191 2.648 2.1383 5.243 1.5094 6.117s-2.1846.331-2.7274-.404c.383.658.9322 1.204 1.5927 1.583.6604.379 1.4088.577 2.1702.575.7613-.001 1.5089-.203 2.1676-.585s1.2056-.93 1.5856-1.59c.38-.659.58-1.407.5797-2.169-.0002-.761-.2006-1.509-.5811-2.168-.3805-.66-.9276-1.208-1.5866-1.589s-1.4067-.583-2.168-.584z",
    fill: "#37474f"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "m100.568 167.783c3.113-3.112 3.113-8.159 0-11.271-3.1123-3.113-8.1588-3.113-11.2714 0-3.1127 3.112-3.1127 8.159-.0001 11.271 3.1127 3.113 8.1592 3.113 11.2715 0z",
    fill: "#455a64"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "m102.689 163.966c-.309 1.279-.931 2.46-1.81 3.439-.879.978-1.987 1.723-3.2248 2.168-1.2378.444-2.5666.575-3.8673.379-1.3006-.196-2.5322-.711-3.5844-1.5-1.0522-.79-1.892-1.828-2.444-3.021-.5521-1.194-.799-2.506-.7188-3.819s.4852-2.585 1.1785-3.703 1.6533-2.046 2.7938-2.701c-.6927.391-1.3221.884-1.8668 1.463-.1384.597-.2095 1.208-.2119 1.821-.012 1.6.4595 3.166 1.3527 4.494.8933 1.328 2.1668 2.355 3.6536 2.946 1.4868.592 3.1176.721 4.6789.37 1.5615-.351 2.9805-1.165 4.0705-2.336z",
    fill: "#37474f"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "m114.194 174.353 50.828 29.339v-44.71l-50.828-29.34z",
    fill: "#f0f0f0"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "m150.498 186.924v25.156l-50.8212-29.346v-25.149z",
    fill: "#f0f0f0"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "m99.6768 165.966 50.8212 29.346v-8.388l-50.8212-29.339z",
    fill: "#e0e0e0"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "m114.194 138.023 50.828 29.339v-8.38l-50.828-29.347z",
    fill: "#e0e0e0"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "m165.023 158.981 33.881-19.561v44.711l-33.881 19.561z",
    fill: "#fafafa"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "m150.499 186.924 14.524-13.968v30.736l-14.524 8.388z",
    fill: "#fafafa"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "m181.963 129.635-16.94 29.347 33.881-19.562z",
    fill: "#fafafa"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "m162.6 163.172 19.363-33.537v-2.091l-19.363 33.536z",
    fill: "#8ed6e8"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "m162.6 163.172 19.363-33.537v-2.091l-19.363 33.536z",
    fill: "#000",
    opacity: 0.1
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "m131.137 98.2032-19.36 33.5328 50.823 29.342 19.36-33.532z",
    fill: "#8ed6e8"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "m111.779 131.734 50.821 29.346v2.092l-50.821-29.339z",
    fill: "#8ed6e8"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "m111.779 131.734 50.821 29.346v2.092l-50.821-29.339z",
    fill: "#000",
    opacity: 0.15
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "m181.963 127.544 21.177 12.227-1.82 1.045-19.357-11.181z",
    fill: "#8ed6e8"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "m181.963 127.544 21.177 12.227-1.82 1.045-19.357-11.181z",
    fill: "#000",
    opacity: 0.15
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "m201.319 140.816h-2.416v-1.396z",
    fill: "#8ed6e8"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "m201.319 140.816h-2.416v-1.396z",
    fill: "#000",
    opacity: 0.3
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "m121.993 131.337v-10.062l5.793-3.343 5.772 9.996v10.095z",
    fill: "#f0f0f0"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "m127.785 117.932-7.149 4.124-.914-.53 8.063-4.654z",
    fill: "#000",
    opacity: 0.2
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "m133.558 138.023 5.779-10.023 2.953-5.123-8.732 5.051z",
    fill: "#fafafa"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "m120.635 122.056h1.357v-.781z",
    fill: "#000",
    opacity: 0.4
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "m134.935 130.311-7.149-12.379v-1.06l8.043 13.955z",
    fill: "#8ed6e8"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "m134.935 130.311-7.149-12.379v-1.06l8.043 13.955z",
    fill: "#000",
    opacity: 0.1
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "m135.829 130.827-8.043-13.955 8.321-4.806 8.043 13.955z",
    fill: "#8ed6e8"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "m135.829 130.827-8.043-13.955 8.321-4.806 8.043 13.955z",
    fill: "#fff",
    opacity: 0.3
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "m130.673 126.312-5.786-3.343v6.673l5.786 3.343z",
    fill: "#455a64"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "m125.476 129.298v-5.991l5.196 3.005v5.985z",
    fill: "#e0e0e0"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "m124.887 129.642.589-.344 5.197 2.999v.688z",
    fill: "#37474f"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "m146.189 145.311v-10.062l5.799-3.343 5.773 9.996v10.096z",
    fill: "#f0f0f0"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "m151.988 131.906-7.149 4.124-.921-.529 8.07-4.654z",
    fill: "#000",
    opacity: 0.2
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "m157.76 151.998 5.773-10.023 2.952-5.124-8.725 5.051z",
    fill: "#fafafa"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "m144.839 136.03h1.35v-.781z",
    fill: "#000",
    opacity: 0.4
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "m159.137 144.285-7.149-12.379v-1.059l8.036 13.955z",
    fill: "#8ed6e8"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "m159.137 144.285-7.149-12.379v-1.059l8.036 13.955z",
    fill: "#000",
    opacity: 0.1
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "m160.024 144.802-8.036-13.955 8.314-4.813 8.044 13.955z",
    fill: "#8ed6e8"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "m160.024 144.802-8.036-13.955 8.314-4.813 8.044 13.955z",
    fill: "#fff",
    opacity: 0.3
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "m154.867 140.28-5.785-3.336v6.673l5.785 3.343z",
    fill: "#455a64"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "m149.678 143.273v-5.992l5.19 2.999v5.991z",
    fill: "#e0e0e0"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "m149.082 143.617.595-.345 5.19 2.999v.689z",
    fill: "#37474f"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "m114.194 141.723 50.828 29.34v1.893l-16.94 18.165-50.8281-29.346v-1.887z",
    fill: "#8ed6e8"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "m114.194 141.723 50.828 29.34-16.94 18.165-50.8281-29.34z",
    fill: "#8ed6e8"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "m148.083 189.228v1.893l16.94-18.165v-1.893z",
    fill: "#000",
    opacity: 0.1
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "m148.082 191.121-50.8281-29.346v-1.887l50.8281 29.34z",
    fill: "#000",
    opacity: 0.15
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "m119.041 174.346-12.101-6.984v12.856l12.101 6.984z",
    fill: "#263238"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "m107.681 179.788v-11.995l11.359 6.56v11.989z",
    fill: "#fafafa"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "m107.681 167.793v2.8l11.359 6.554v-2.801z",
    fill: "#f0f0f0"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "m106.94 180.218.741-.43 11.36 6.554v.86z",
    fill: "#37474f"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "m106.94 173.79.741-.43 11.36 6.554v.86z",
    fill: "#37474f"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "m112.738 183.568.742.43v-12.856l-.742-.43z",
    fill: "#37474f"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "m140.82 186.924-12.101-6.984v12.856l12.101 6.984z",
    fill: "#263238"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "m129.46 192.366v-11.996l11.36 6.554v11.995z",
    fill: "#fafafa"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "m129.46 180.37v2.794l11.36 6.56v-2.8z",
    fill: "#f0f0f0"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "m128.719 192.796.742-.43 11.359 6.553v.861z",
    fill: "#37474f"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "m128.719 186.368.742-.43 11.359 6.554v.86z",
    fill: "#37474f"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "m134.518 196.146.741.43v-12.856l-.741-.43z",
    fill: "#37474f"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "m157.76 188.328 12.101-6.991v12.856l-12.101 6.984z",
    fill: "#263238"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "m169.12 193.763v-11.996l-11.36 6.561v11.988z",
    fill: "#e6e6e6"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "m169.12 181.767v1.232l-11.36 6.553v-1.224z",
    fill: "#e0e0e0"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "m169.861 194.193-.741-.431-11.36 6.554v.861z",
    fill: "#37474f"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "m169.861 187.765-.741-.43-11.36 6.553v.861z",
    fill: "#37474f"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "m164.063 197.542-.742.431v-12.856l.742-.43z",
    fill: "#37474f"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "m176.898 146.721 12.102-6.984v12.856l-12.102 6.984z",
    fill: "#263238"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "m188.258 152.163v-11.995l-11.36 6.553v11.996z",
    fill: "#e6e6e6"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "m188.258 140.168v1.231l-11.36 6.554v-1.232z",
    fill: "#e0e0e0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#37474f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m189 152.593-.742-.43-11.36 6.554v.86z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m189 146.165-.742-.43-11.36 6.56v.861z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m183.201 155.943-.742.43v-12.856l.742-.43z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m177.124 196.708v-22.355l12.101-6.991v22.362z"
  }))), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "m188.781 189.387v-21.767l-11.657 6.733v21.766z",
    fill: "#455a64"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "m189.225 167.362-.444.258v21.767l.444.337z",
    fill: "#263238"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "m246.162 11.0598c-.037-1.7532-.487-3.47295-1.312-5.01988-.826-1.54694-2.005-2.87753-3.441-3.88393-1.324-.84072-2.595-.9665-3.522-.48987-5.594 2.80684-44.903 28.00878-47.412 29.25338h-.033c-.264.1754-.477.4182-.617.7032-.139.2851-.201.6021-.177.9187.015.8837.24 1.7512.655 2.5313.416.7802 1.01 1.4508 1.735 1.957.251.1957.549.3211.864.363.316.0418.637-.0012.93-.1247h.039c3.972-2.1912 42.772-18.7277 50.702-22.9777.934-.5164 1.536-1.6285 1.589-3.2305z",
    fill: "#8ed6e8"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "m244.62 5.62481c-.778-1.39601-1.879-2.58545-3.21-3.46883-1.324-.84073-2.582-.96651-3.509-.49649l-.119.06619c-5.104 2.60825-34.357 21.26972-44.201 27.34022l-.066.0397-.398.245-.119.0728-.225.139-.265.1589c-1.039.662-1.741 1.0459-1.986 1.1849h-.033c-.084.05-.162.11-.231.1788-.186.1905-.332.4165-.428.6644-.097.2479-.143.5127-.135.7787-.013.1873-.013.3754 0 .5627 0 .0728 0 .1456.033.2185.033.0728.04.225.066.3442.027.1191.046.1853.073.2714.026.0861.066.2185.106.3244s.059.1589.086.2383v.0397z",
    fill: "#000",
    opacity: 0.1
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "m192.031 37.0363c-.721-.505-1.313-1.1726-1.729-1.9489-.415-.7763-.641-1.6394-.661-2.5196.06-1.6152 1.212-2.2375 2.582-1.3835.722.5055 1.315 1.1742 1.73 1.9518.415.7775.641 1.642.66 2.5232-.053 1.6153-1.212 2.2442-2.582 1.377z",
    fill: "#8ed6e8"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "m180.28 38.1219c.016.6762.19 1.3393.508 1.936.319.5968.773 1.1104 1.326 1.4997.192.1485.42.2434.661.2748s.485-.0018.709-.0961l9.506-5.0642c.202-.134.365-.3192.472-.5367s.154-.4594.137-.7012c-.014-.6764-.188-1.3399-.506-1.9368-.319-.5969-.773-1.1104-1.327-1.4989-.191-.1503-.419-.2467-.66-.2793s-.486-.0002-.711.0939l-9.506 5.0642c-.203.1346-.366.3209-.473.5397-.107.2187-.154.462-.136.7049z",
    fill: "#37474f"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "m180.903 36.8773c-.206.133-.372.3186-.481.5374-.109.2189-.158.4631-.141.7072-.004.5024.095 1.0002.291 1.463l12.26-6.5405c-.278-.4151-.636-.7707-1.053-1.0459-.191-.1503-.419-.2467-.66-.2793-.24-.0326-.486-.0002-.71.0939z",
    fill: "#263238"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "m192.482 46.5557c0-6.0903-4.025-12.1806-12.081-16.8278-16.1-9.3009-42.209-9.3009-58.315 0-8.05 4.634-12.075 10.7375-12.075 16.8278v11.2539c0 6.0903 4.025 12.1806 12.082 16.8344 16.099 9.2678 42.208 9.2678 58.308 0 8.056-4.634 12.081-10.7441 12.081-16.8344zm-68.417-13.3788c7.19-4.1507 16.835-6.4346 27.142-6.4346s19.972 2.2839 27.142 6.4346c6.5 3.7535 10.082 8.5066 10.082 13.3854 0 4.8789-3.582 9.6254-10.082 13.3789-7.19 4.1506-16.835 6.4345-27.142 6.4345s-19.972-2.2839-27.142-6.4345c-6.507-3.7535-10.082-8.5066-10.082-13.3789 0-4.8722 3.595-9.6319 10.082-13.3854z",
    fill: "#8ed6e8"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "m122.079 63.3901c16.106 9.301 42.209 9.301 58.315 0s16.106-24.3679 0-33.6622c-16.106-9.2944-42.209-9.301-58.315 0-16.106 9.3009-16.093 24.3679 0 33.6622zm-8.089-16.8278c0-4.8789 3.581-9.632 10.082-13.3854 7.196-4.1507 16.841-6.4346 27.141-6.4346 10.301 0 19.973 2.2839 27.142 6.4346 6.501 3.7534 10.082 8.5065 10.082 13.3854s-3.581 9.6253-10.082 13.3788c-7.196 4.1507-16.841 6.4346-27.142 6.4346-10.3 0-19.972-2.2839-27.141-6.4346-6.494-3.7535-10.076-8.5066-10.076-13.3788z",
    fill: "#fff",
    opacity: 0.3
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "m113.997 46.5557c.023 1.9836.579 3.9246 1.608 5.6203 1.635-2.8333 4.515-5.4879 8.48-7.7718 7.183-4.1573 16.835-6.4412 27.142-6.4412s19.972 2.2839 27.142 6.4412c3.972 2.2839 6.845 4.9385 8.486 7.7718 1.025-1.6975 1.578-3.6377 1.602-5.6203 0-4.8723-3.581-9.6254-10.088-13.3788-7.183-4.1507-16.835-6.4346-27.142-6.4346s-19.979 2.2839-27.142 6.4346c-6.507 3.7534-10.088 8.5065-10.088 13.3788z",
    fill: "#8ed6e8"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "m113.997 46.5557c.023 1.9836.579 3.9246 1.608 5.6203 1.635-2.8333 4.515-5.4879 8.48-7.7718 7.183-4.1573 16.835-6.4412 27.142-6.4412s19.972 2.2839 27.142 6.4412c3.972 2.2839 6.845 4.9385 8.486 7.7718 1.025-1.6975 1.578-3.6377 1.602-5.6203 0-4.8723-3.581-9.6254-10.088-13.3788-7.183-4.1507-16.835-6.4346-27.142-6.4346s-19.979 2.2839-27.142 6.4346c-6.507 3.7534-10.088 8.5065-10.088 13.3788z",
    fill: "#000",
    opacity: 0.1
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "m124.066 38.2609c7.195-4.1507 16.841-6.4412 27.141-6.4412 10.301 0 19.972 2.2905 27.142 6.4412 5.362 3.0981 8.731 6.8714 9.751 10.8368-1.02 3.9719-4.389 7.7452-9.751 10.8434-7.196 4.1506-16.841 6.4345-27.142 6.4345-10.3 0-19.972-2.2839-27.141-6.4345-5.363-3.0982-8.732-6.8781-9.752-10.8434 1.033-3.9654 4.403-7.7387 9.752-10.8368z",
    fill: "#fff",
    opacity: 0.4
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "m141.528 69.679v11.2539c-7.123-.993-13.902-3.0915-19.436-6.3022-8.056-4.6339-12.081-10.7441-12.081-16.841v-11.2538c.003-1.2408.167-2.4759.49-3.6741-1.986 7.2488 1.906 14.9213 11.578 20.5217 5.574 3.2239 12.326 5.3224 19.449 6.2955z",
    fill: "#000",
    opacity: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouseSearch);
export default __webpack_public_path__ + "static/media/house-search.d17249eb950dd6a3ef72aee1b9fd383e.svg";
export { ForwardRef as ReactComponent };